document.addEventListener('DOMContentLoaded',function(){ if(window.__swxHome)return;window.__swxHome=1;
/* ---------- Scroll reveal ---------- */
(function(){
  const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.sx-rv').forEach(el=>io.observe(el));
})();

/* ---------- Google reviews carousel ---------- */
(function(){
  const t=document.getElementById('sx-grevTrack');if(!t)return;
  const step=()=>Math.min(t.clientWidth*0.85,346);
  const prev=document.getElementById('sx-grevPrev'),next=document.getElementById('sx-grevNext');
  next&&next.addEventListener('click',()=>t.scrollBy({left:step(),behavior:'smooth'}));
  prev&&prev.addEventListener('click',()=>t.scrollBy({left:-step(),behavior:'smooth'}));
})();

/* ---------- Quick-links carousel ---------- */
(function(){
  const t=document.getElementById('sx-qTrack');if(!t)return;
  const step=()=>Math.min(t.clientWidth*0.8,436);
  document.getElementById('sx-qNext').addEventListener('click',()=>t.scrollBy({left:step(),behavior:'smooth'}));
  document.getElementById('sx-qPrev').addEventListener('click',()=>t.scrollBy({left:-step(),behavior:'smooth'}));
})();

/* custom cursor is pure CSS now (see the @media(pointer:fine) cursor rule) */

/* ---------- Hero banner slider ---------- */
(function(){
  const track=document.getElementById('sx-bslides');if(!track)return;
  const slides=[...track.children];const dotsWrap=document.getElementById('sx-bDots');
  let i=0,timer;
  slides.forEach((s,idx)=>{const d=document.createElement('div');d.className='sx-bdot'+(idx===0?' on':'');d.addEventListener('click',()=>go(idx));dotsWrap.appendChild(d);});
  const dots=[...dotsWrap.children];
  function go(n){i=(n+slides.length)%slides.length;track.style.transform=`translateX(${-i*100}%)`;slides.forEach((s,idx)=>s.classList.toggle('active',idx===i));dots.forEach((d,idx)=>d.classList.toggle('on',idx===i));reset();}
  function next(){go(i+1);} function prev(){go(i-1);}
  function reset(){clearInterval(timer);timer=setInterval(next,5500);}
  document.getElementById('sx-bNext').addEventListener('click',next);
  document.getElementById('sx-bPrev').addEventListener('click',prev);
  let x0=null;const el=document.getElementById('sx-bslider');
  el.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
  el.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45){dx<0?next():prev();}x0=null;});
  // premium banner motion: the HD product photo breathes, drifts, and tilts with the cursor
  const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const fine=matchMedia('(pointer:fine)').matches;
  if(!reduce){
    let tx=0,ty=0,cx=0,cy=0,t0=performance.now();
    if(fine){
      el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();tx=(e.clientX-r.left)/r.width-0.5;ty=(e.clientY-r.top)/r.height-0.5;});
      el.addEventListener('pointerleave',()=>{tx=0;ty=0;});
    }
    (function frame(now){
      cx+=(tx-cx)*0.06;cy+=(ty-cy)*0.06;
      const t=(now-t0)/1000;
      const act=slides[i];
      const img=act.querySelector('.sx-bslide__img');
      const inr=act.querySelector('.sx-bslide__in');
      if(img){
        const breathe=1.085+Math.sin(t*0.5)*0.018;           // slow zoom in/out
        const fx=Math.sin(t*0.35)*10, fy=Math.cos(t*0.45)*8;  // idle float
        const px=cx*48, py=cy*34;                              // cursor parallax
        img.style.transform=`scale(${breathe.toFixed(3)}) translate(${(fx+px).toFixed(1)}px,${(fy+py).toFixed(1)}px)`;
      }
      if(inr) inr.style.transform=`translate(${(cx*-18).toFixed(1)}px,${(cy*-12).toFixed(1)}px)`;
      requestAnimationFrame(frame);
    })(t0);
  }
  reset();
})();

/* ---------- Home motion: elevate banner · reviews · benefits · pairing CTA ---------- */
(function(){
  const still=matchMedia('(prefers-reduced-motion:reduce)').matches,fine=matchMedia('(pointer:fine)').matches;
  // cursor-follow glow / parallax: write CSS vars only (no layout reads besides the hovered element's rect)
  function track(el,norm){el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top;
    el.style.setProperty('--mx',x+'px');el.style.setProperty('--my',y+'px');
    if(norm){el.style.setProperty('--px',(x/r.width-0.5).toFixed(3));el.style.setProperty('--py',(y/r.height-0.5).toFixed(3));}},{passive:true});
    if(norm)el.addEventListener('pointerleave',()=>{el.style.setProperty('--px',0);el.style.setProperty('--py',0);});}
  if(fine){document.querySelectorAll('.sx-grev__card,.sx-ben').forEach(el=>track(el,false));document.querySelectorAll('.sx-ebanner,.sx-cta2').forEach(el=>track(el,true));}
  // magnetic buttons
  if(fine&&!still)document.querySelectorAll('.sx-ebanner .sx-btn,.sx-cta2 .sx-btn').forEach(b=>{
    b.addEventListener('pointermove',e=>{const r=b.getBoundingClientRect();b.style.setProperty('--bx',((e.clientX-r.left-r.width/2)*0.22).toFixed(1)+'px');b.style.setProperty('--by',((e.clientY-r.top-r.height/2)*0.3).toFixed(1)+'px');});
    b.addEventListener('pointerleave',()=>{b.style.setProperty('--bx','0px');b.style.setProperty('--by','0px');});});
  // stagger indexes
  document.querySelectorAll('.sx-grev__card').forEach((c,i)=>c.style.setProperty('--i',i));
  document.querySelectorAll('.sx-bens .sx-ben').forEach((c,i)=>c.style.setProperty('--i',i));
  // stars -> individually animated glyphs
  document.querySelectorAll('.sx-grev .sx-st').forEach(st=>{[...st.childNodes].forEach(n=>{if(n.nodeType===3&&n.textContent.includes('★')){
    const f=document.createDocumentFragment();[...n.textContent].forEach((ch,i)=>{if(ch==='★'){const s=document.createElement('i');s.textContent='★';s.style.setProperty('--i',i);f.append(s);}else f.append(ch);});n.replaceWith(f);}});});
  // benefit icons: draw-in strokes + per-icon hover keys
  const keys=['shield','check','truck','clock'];
  document.querySelectorAll('.sx-bens .sx-ben').forEach((b,i)=>{b.dataset.k=keys[i]||'';const svg=b.querySelector('.sx-ic svg');if(!svg)return;
    svg.querySelectorAll('path,rect,circle').forEach(p=>p.setAttribute('pathLength','1'));svg.classList.add('drw');});
  // count-up "108 reviews" when the reviews block reveals
  const cnt=document.querySelector('.sx-grev__sum .sx-cnt b');
  function countUp(){if(!cnt||cnt.dataset.done)return;cnt.dataset.done=1;const m=cnt.textContent.match(/(\d+)/);if(!m)return;
    const to=+m[1],rest=cnt.textContent.replace(m[1],'%n%');if(still)return;const t0=performance.now();
    (function step(now){const k=Math.min(1,(now-t0)/1400),v=Math.round(to*(1-Math.pow(1-k,3)));cnt.textContent=rest.replace('%n%',v);if(k<1)requestAnimationFrame(step);})(t0);}
  // reviews auto-advance: the progress bar's animationend drives the next slide; hover/focus pauses it via CSS
  const track_=document.getElementById('sx-grevTrack'),nav=document.querySelector('.sx-grev__nav');
  let bar=null;
  if(track_&&nav&&!still){bar=document.createElement('div');bar.className='sx-grev__bar';bar.innerHTML='<i></i>';nav.prepend(bar);
    const step=()=>Math.min(track_.clientWidth*0.85,346);
    const restart=()=>{bar.classList.remove('run');void bar.offsetWidth;bar.classList.add('run');};
    bar.addEventListener('animationend',()=>{const end=track_.scrollLeft+track_.clientWidth>=track_.scrollWidth-4;
      track_.scrollTo({left:end?0:track_.scrollLeft+step(),behavior:'smooth'});restart();});
    nav.querySelectorAll('button').forEach(b=>b.addEventListener('click',restart));
    track_.addEventListener('touchstart',()=>bar.classList.add('hold'),{passive:true});
    track_.addEventListener('touchend',()=>{bar.classList.remove('hold');restart();},{passive:true});
    bar.restart=restart;}
  // visibility: start reveals/autoplay when on screen, pause infinite animations when off screen
  const sections=[...new Set([...document.querySelectorAll('.sx-ebanner,.sx-grev,.sx-bens,.sx-cta2')].map(el=>el.closest('.sx')))];
  const io=new IntersectionObserver(es=>es.forEach(e=>{const s=e.target;s.classList.toggle('mo-off',!e.isIntersecting);
    if(e.isIntersecting&&s.querySelector('.sx-grev')){countUp();if(bar&&!bar.classList.contains('run'))bar.restart();}
    if(bar&&s.querySelector('.sx-grev'))bar.classList.toggle('hold',!e.isIntersecting);}),{threshold:0.15});
  sections.forEach(s=>s&&io.observe(s));
})();
});
